'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.onClick = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _framework7React = require('framework7-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  whiteBackground: {
    backgroundColor: '#ffffff',
    margin: 0,
    paddingTop: '5px',
    paddingBottom: '5px',
    display: 'flex',
    zIndex: 30
  },
  whiteBackgroundInternalGap: {
    backgroundColor: '#ffffff',
    width: '5px'
  },
  whiteBackgroundContent: {
    flex: 1
  }
};

var _onClick = function _onClick(event, props) {
  event.preventDefault();
  event.stopPropagation();

  var originalOnClick = props.onClick;

  if (originalOnClick) {
    // do not follow default href="#"
    originalOnClick();
  }
};

exports.onClick = _onClick;
var Button = function Button(props) {
  var content = props.label || props.children || '';

  return _react2.default.createElement(
    'div',
    { style: styles.whiteBackground },
    _react2.default.createElement('div', { style: styles.whiteBackgroundInternalGap }),
    _react2.default.createElement(
      _framework7React.Button,
      _extends({}, props, {
        onClick: function onClick(event) {
          _onClick(event, props);
        },
        style: _extends({}, styles.whiteBackgroundContent)
      }),
      content.toUpperCase()
    ),
    _react2.default.createElement('div', { style: styles.whiteBackgroundInternalGap })
  );
};

Button.propTypes = {
  color: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  label: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node])
};

Button.defaultProps = {
  onClick: function onClick() {},
  label: null,
  children: null
};

exports.Button = Button;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components-framework7/Button.js
// module id = 285
// module chunks = 0